module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-regular.cab12fcd.woff2";